// extracted by mini-css-extract-plugin
module.exports = {"countryStats":"Details_countryStats__HhZdI","countryActivities":"Details_countryActivities__3cfoQ"};